(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["header"]) return;
  try {
    
  $(document).ready(function() {
    var $headerMenu = $('.site-nav-menu-btn');
    var $headerOverlay = $('.site-nav-overlay');
    var $headerOverlayBtn = $('.site-nav-overlay-btn');

    $headerMenu.on('click', function(evt) {
      evt.preventDefault();

      $headerOverlay.addClass('is-active');
    });

    $headerOverlayBtn.on('click', function(evt) {
      evt.preventDefault();

      $headerOverlay.removeClass('is-active');
    });
  });

  } catch(e) { console.error(e); }
})();

})();
